



























import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { isAllowEditDates } from "@/plugins/modules-detect";
import { PaymentCreate as IPaymentCreate } from "@/api/models/payment-create";

@Component({ components: { CustomDatepicker, CustomButton } })
export default class BillPaymentAdd extends Vue {
  @Prop() debtNumber!: number;
  @Prop() payment!: any;
  form!: IPaymentCreate;
  data() {
    return {
      form: {}
    };
  }

  checkMaxAmount(value: number) {
    return value > this.$converter.getPrice(this.debtNumber)
      ? this.$converter.getPrice(this.debtNumber)
      : value;
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  submit() {
    let params: IPaymentCreate = {
      amount: this.$converter.setPrice(this.form.amount),
      paymentAt: this.form.paymentAt
    };
    this.$emit("submit", params);
  }

  created() {
    this.form.amount = this.$converter.getPrice(this.debtNumber);
    if (this.payment) {
      this.form.paymentAt = this.payment.item.paymentAt;
      this.form.amount = this.$converter.getPrice(this.payment.item.amount);
      this.debtNumber += this.payment.item.amount;
    }
  }
}
